const XL_BREAKPOINT = '(min-width: 79.9375rem)';
const ANIMATION_DURATION_MS = 220;

document.addEventListener('DOMContentLoaded', () => {
    const detailsItems = document.querySelectorAll('[data-detail-mobile-accordion-item]');
    let wasDesktop = null;

    if (!detailsItems.length) {
        return;
    }

    const syncAriaExpanded = () => {
        detailsItems.forEach((item) => {
            const summary = item.querySelector('[data-detail-mobile-accordion-summary]');

            if (summary) {
                summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
            }
        });
    };

    const getAnimatedContent = (details) => (
        details.querySelector('.detail-mobile-accordion__content-inner')
        || details.querySelector('.detail-mobile-accordion__content')
    );

    const setByViewport = () => {
        const isDesktop = isDesktopViewport();

        if (wasDesktop === isDesktop) {
            return;
        }

        wasDesktop = isDesktop;

        detailsItems.forEach((item) => {
            const content = getAnimatedContent(item);

            item.removeAttribute('data-accordion-animating');
            item.open = isDesktop;

            if (content) {
                content.style.height = '';
                content.style.transition = '';
            }
        });

        syncAriaExpanded();
    };

    setByViewport();

    window.addEventListener('resize', setByViewport);

    const animateOpen = (details) => {
        const content = getAnimatedContent(details);

        if (!content) {
            details.open = true;
            syncAriaExpanded();
            return;
        }

        details.setAttribute('data-accordion-animating', 'true');
        details.open = true;
        syncAriaExpanded();

        content.style.transition = 'none';
        content.style.height = '0px';
        content.offsetHeight;

        window.requestAnimationFrame(() => {
            content.style.transition = `height ${ANIMATION_DURATION_MS}ms ease`;
            content.style.height = `${content.scrollHeight}px`;
        });

        window.setTimeout(() => {
            content.style.height = '';
            content.style.transition = '';
            details.removeAttribute('data-accordion-animating');
        }, ANIMATION_DURATION_MS);
    };

    const animateClose = (details) => {
        const content = getAnimatedContent(details);

        if (!content) {
            details.open = false;
            syncAriaExpanded();
            return;
        }

        details.setAttribute('data-accordion-animating', 'true');
        content.style.transition = 'none';
        content.style.height = `${content.scrollHeight}px`;
        content.offsetHeight;

        window.requestAnimationFrame(() => {
            content.style.transition = `height ${ANIMATION_DURATION_MS}ms ease`;
            content.style.height = '0px';
        });

        window.setTimeout(() => {
            details.open = false;
            content.style.height = '';
            content.style.transition = '';
            details.removeAttribute('data-accordion-animating');
            syncAriaExpanded();
        }, ANIMATION_DURATION_MS);
    };

    document.addEventListener('click', (event) => {
        const summary = event.target.closest('[data-detail-mobile-accordion-summary]');

        if (!summary) {
            return;
        }

        const details = summary.closest('[data-detail-mobile-accordion-item]');
        const isDesktop = isDesktopViewport();

        if (isDesktop) {
            event.preventDefault();

            if (details) {
                details.open = true;
            }

            syncAriaExpanded();
            return;
        }

        const isTriggerClick = event.target.closest('[data-detail-mobile-accordion-trigger]');

        event.preventDefault();

        if (!details || !isTriggerClick || details.hasAttribute('data-accordion-animating')) {
            return;
        }

        if (details.open) {
            animateClose(details);
            return;
        }

        animateOpen(details);
    }, true);

    document.addEventListener('keydown', (event) => {
        const summary = event.target.closest('[data-detail-mobile-accordion-summary]');

        if (!summary) {
            return;
        }

        if (isDesktopViewport()) {
            event.preventDefault();
            const details = summary.closest('[data-detail-mobile-accordion-item]');

            if (details) {
                details.open = true;
            }

            syncAriaExpanded();
            return;
        }

        if (event.key !== 'Enter' && event.key !== ' ') {
            return;
        }

        const details = summary.closest('[data-detail-mobile-accordion-item]');

        event.preventDefault();

        if (!details || details.hasAttribute('data-accordion-animating')) {
            return;
        }

        if (details.open) {
            animateClose(details);
            return;
        }

        animateOpen(details);
    });

    detailsItems.forEach((item) => {
        item.addEventListener('toggle', () => {
            if (isDesktopViewport() && !item.open) {
                item.open = true;
            }

            syncAriaExpanded();
        });
    });
});
    const isDesktopViewport = () => window.matchMedia(XL_BREAKPOINT).matches;
